import React from 'react';
import './journal-doc.scss';

const Handbook = () => {
  return (
    <div className="journal-doc handbook-container">
      <h1>“ЭМНЭЛЗҮЙН АРЬС СУДЛАЛ СЭТГҮУЛ” –ИЙН ЗОХИОГЧИД ӨГӨХ ЗААВАР</h1>

      <section>
        <h2>Нэг. Сэтгүүлийн зорилго болон хамрах хүрээ</h2>
        <p>
          Эмнэлзүйн Арьс Судлал Сэтгүүлийн гол зорилго нь арьс судлаачдын мэдлэг, туршлагаа
          хуваалцах, ахиулах чиглэлт талбар болж мэдлэгийг уламжлан түгээх эх үүсвэр болох замаар
          Монголын арьс судлалын салбарыг хөгжүүлэхэд оршино.
        </p>
        <p>
          Сэтгүүл нь арьс судлал ба түүнтэй нягт холбоотой дархлаа судлал, молекул биологи
          судлал, эрүүл ба эмгэг физиологи, доторын анагаах ухаан болон бусад холбоотой шинжлэх
          ухааны эрдэм шинжилгээний бүтээлийг хэвлэнэ.
        </p>
      </section>

      <section>
        <h2>Хоёр. Сэтгүүлд хэвлүүлэх бүтээлийн хэлбэрүүд</h2>
        <p>
          Сэтгүүл нь эрдэм шинжилгээний өгүүллэг (original articles), эмнэлзүйн тохиолдол (case
          reports), сэдэвчилсэн тойм (reviews), шаардлагатай тохиолдолд улсын стандарт болон
          үндэсний зөвлөмж (guidelines) зэргийг нийтлэнэ.
        </p>

        <h3>1. Эрдэм шинжилгээний өгүүлэл</h3>
        <p>
          Эрдэм шинжилгээний өгүүлэл нь арьс судлал болон түүнтэй нягт уялдаат анагаах ухааны
          салбарын туршилт судалгаа болон эмнэлзүйн судалгаат агуулсан байна.
        </p>
        <p>
          Судалгаа нь чанарын өндөр түвшинд хийгдсэн, олон нийтийн сонирхлыг татахуйц
          байхаас гадна анагаах ухааны салбарт гарч буй ололт, дэвшилтэт арга, технологийг тусгасан
          шинэ мэдээллийг түгээх зорилготой байна.
        </p>
        <p>
          Эрдэм шинжилгээний өгүүлэл нь 200 хүртэл үгтэй монгол, англи товч утга буюу
          хураангуйтай байна. Товч утга, ашигласан хэвлэлийн жагсаалтыг оруулалгуй 6000 хүртэл
          үгийн тоотой байна.
        </p>
        <p>Өгүүллийн бүтэц нь дараах дэд хэсгүүдээс тогтоно:</p>
        <ul>
          <li>Гарчиг бүхий хуудас</li>
          <li>Товч утга</li>
          <li>Түлхүүр үг</li>
          <li>Үндэслэл</li>
          <li>Материал арга зүй</li>
          <li>Үр дүн</li>
          <li>Дүгнэлт</li>
          <li>Ашиг сонирхлын зөрчил</li>
          <li>Талархал</li>
          <li>Ашигласан хэвлэл</li>
          <li>Хүснэгт</li>
          <li>Зураг</li>
        </ul>

        <h3>2. Эмнэлзүйн тохиолдол</h3>
        <p>
          Эмнэлзүйн тохиолдол нь анагаахын шинжлэх ухааны салбар дахь өвчний шинж тэмдэг,
          оношилгоо, эмчилгээнд шинэ ойлголтыг мэдээлэх зорилготой байна.
        </p>
        <p>
          Тохиолдол нь 100 хүртэл үгийн тоотой монгол, англи хураангуйтай байх ба хураангуй,
          ашигласан хэвлэлийн жагсаалтыг оруулалгуй 1000 хүртэл үгийн тоотой байна.
        </p>
        <p>Эмнэлзүйн тохиолдол нь дараах бүтэц зохион байгуулалттай байна:</p>
        <ul>
          <li>Гарчиг бүхий хуудас</li>
          <li>Товч утга</li>
          <li>Түлхүүр үг</li>
          <li>Үндэслэл</li>
          <li>Эмнэлзүйн тохиолдолын мэдээлэл</li>
          <li>Дүгнэлт</li>
          <li>Ашиг сонирхлын зөрчил</li>
          <li>Талархал</li>
          <li>Ном зүй</li>
          <li>Хүснэгт</li>
          <li>Зураг</li>
        </ul>
        <p>Хүснэгт/зураг нь 4-с багагүй 10-с олонгүй байна.</p>

        <h3>3. Сэдэвчилсэн тойм өгүүлэл</h3>
        <p>
          Тойм өгүүллийн агуулга редакцийн зөвлөлийн даргын саналаар бичигдэнэ. Сэтгүүлийн
          зорилго, хамрах хүрээнд уялдуулан салбартаа танигдсан эрдэмтэн урилгаар тойм өгүүлэл
          бичнэ.
        </p>
        <p>
          Тойм өгүүлэл нь анагаахын шинжлэх ухааны хамгийн сүүлийн үеийн чухал сэдвийг
          хөндсөн байна.
        </p>
        <p>
          Тойм өгүүлэл нь хураангуй болон түлхүүр үгсийг оруулалгуй 8000 хүртэл үгийн тоотой
          байна. Тойм өгүүлэл нь 200 хүртэл үгтэй хураангуй болон 5 хүртэлх түлхүүр үгстэй байна.
        </p>
        <p>Тойм өгүүлэл нь дараах дэд хэсгүүд бүхий дараалалтай байна:</p>
        <ul>
          <li>Гарчиг</li>
          <li>Хураангуй</li>
          <li>Түлхүүр үг</li>
          <li>Танилцуулга</li>
          <li>Арга аргачлал</li>
          <li>Үр дүн</li>
          <li>Дүгнэлт</li>
          <li>Ашиг сонирхлын зөрчил</li>
          <li>Талархал</li>
          <li>Ном зүй</li>
          <li>Хүснэгт</li>
          <li>Диаграм болон зураг(ууд)</li>
        </ul>

        <h3>4. Улсын стандарт, үндэсний зөвлөмж</h3>
        <p>
          Улсын стандартыг хэвлэхдээ стандартчилал хэмжилзүйн үндэсний төвөөр баталгаажсан
          стандартыг зохиогчийн зөвшөөрөлтэй хэвлэн нийтлэнэ.
        </p>
        <p>
          Үндэсний зөвлөмжийг редакцын зөвлөлийн зөвлөгөөөр, эрдмийн цол зэрэгтэй, тухайн
          салбартаа мэргэшсэн хүнээр урилгаар бичүүлэн редакцын зөвлөлөөр хэлэлцэн нийтлэнэ.
        </p>
      </section>

      <section>
        <h2>Гурав. Бүтээлд тавигдах ерөнхий шаардлага</h2>
        <p>
          Эх бичмэл (manuscript) нь утга төгс, товч тодорхой, хэлзүйн болоод дүрмийн ямар нэг
          алдаагүй, нийтлэлийн шаардлагыг хангасан, хэвлэгдэхүйц чанартай байна.
        </p>
        <p>
          Сэтгүүлд нийтлүүлэхээр ирүүлж байгаа бүтээл нь хураангуйгаас бусад хэлбэрээр өмнө
          өмнө ямар нэгэн байдлаар хэвлэн нийтлэгдээгүй, нийтийн хүртээл болоогүй байна.
        </p>
        <p>
          Эх бичмэлийг Microsoft Word программаар A4 (210 x 297 мм) цаасан дээр тал бүрээс 20 мм зай
          авч, үсгийн 11pt хэмжээтэй, Times New Roman фонтоор, мөр хоорондын зайг 1.5-аар
          тохируулан бичсэн байна.
        </p>
        <p>
          Эх бичмэлд хэрэглэгдсэн бүх нэгжийг метрийн системээр бичнэ. Жишээ нь: м, см,
          л, мл, кг, гр, мг, мкг, нг, пг, °C гэх мэт.
        </p>

        <h3>Гарчиг хуудас</h3>
        <p>
          Энэ хуудас нь өгүүллийн гарчиг, зохиогчдын овог, нэр болон харьяаллаас
          тогтоно. Зохиогчийн харьяалагдах байгууллагыг бичихдээ тоон цифр ашиглан онолдуулна.
        </p>

        <h3>Хураангуй</h3>
        <p>
          Хураангуй нь 200 үгнээс илүүгүй тоотой байх ба судалгааны өгүүллийн
          товч тодорхой хураангуй хэлбэр юм.
        </p>

        <h3>Түлхүүр үг</h3>
        <p>5 хүртэлх тооны түлхүүр үгтэй байна. Түлхүүр үгийг сонгохдоо "MeSH" зааврын дагуу сонгоно.</p>

        <h3>Арга аргачлал</h3>
        <p>
          Энэ хэсэгт судалгаанд хэрэглэгдсэн урвалж, материал болон
          судалгаанд хэрэглэсэн арга, аргачлалыг бичих ба тэрхүү аргачлалыг уншигч дагаж хийж
          болохуйцаар ойлгомжтой тодорхой бичсэн байна.
        </p>

        <h3>Үр дүн</h3>
        <p>
          Үр дүн нь логик дараалалтай бичигдсэн байх ба хүснэгт, зураг зэрэг нь
          дурьдагдсан дарааллын дагуу дугаарлагдсан байна.
        </p>

        <h3>Хэлцэмж</h3>
        <p>
          Энэ хэсэгт судалгааныхаа үр дүнг бусад судлаачдын үр дүнтэй харьцуулан
          бичих ба тухайн салбарынхаа мэдлэгтэй хэлэлцүүлэн дүгнэж бичнэ.
        </p>

        <h3>Дүгнэлт</h3>
        <p>
          Дүгнэлтийг судалгааны үр дүнгээр баталгаажсан дата (мэдээлэл) дээр
          үндэслэн товч, тодорхой, шийдвэртэй байдлаар бичсэн байна.
        </p>

        <h3>Ашигласан хэвлэл</h3>
        <p>
          Ашигласан хэвлэлийн жагсаалтыг бичихдээ текст хэсэгт
          дурьдагдсан дарааллаар дугаарлана. Текст хэсэгт ишлэл авахдаа дөрвөлжин хашилт "[]"-н
          дотор тооны дарааллаар бичнэ.
        </p>
        <p>Жишээ нь:</p>
        <ul>
          <li>Эрдэм шинжилгээний өгүүлэл: Б.Уянга, Г.Золжаргал, Г.Цогзол,. нарын. Хайрст удд евчтэй хүмүүсийн идэдсийн IL-17, IL-31 цитокиний түвшинг загатнаатай харьцуулсан дүн. Эмнэлзүйн арьс судлал сэтгүүл. 2016; 3: 22-26.</li>
          <li>Номноос: Зохиогчийн овгийн эхний үсэг. зохиогчийн нэр, Номын нэр, хэвлэгдсэн хот, хэвлэгдсэн улс; хэвлэгдсэн он. Хуу. эхлэл хуудасны дугаар – төгсгөл хуудасны дугаар.</li>
          <li>Диссертациас: Зохиогчийн овгийн эхний үсэг. зохиогчийн нэр, диссертацийн сэдэв, хэвлэгдсэн хот, хэвлэгдсэн улс; их сургуулийн нэр, хэвлэгдсэн он.</li>
          <li>Вэбсайтаас: Байгууллатын нэр. Вэб хуудсын нэр [мэдээлэл авсан он, сар, өдөр] холбоос: вэбсайт хаяг.</li>
        </ul>
      </section>

      <section>
        <h2>Дөрөв. Бүтээлийг хэвлэх эсэхийг шийдвэрлэх</h2>
        <p>
          Тус сэтгүүл нь дээр заасан бичиглэлийн шаардлага хангасан, мэргэжилтний түвшинд хянагдсан
          бүтээлийг хэвлэнэ.
        </p>
        <p>Сэтгүүлд хэвлэх эсэхийг дараах шалгууруудаар шийдвэрлэнэ:</p>
        <ol type="A">
          <li>Сэтгүүлийн зүгээс тавигдах форматын шаардлагад нийцэж буй эсэх.</li>
          <li>Сэтгүүлийн редакциас томилсон редакцийн зөвлөлийн 2 гишүүн болон тухайн салбарыг сайн мэдэх хяналтын 1 мэргэжилтэнд тухайн бүтээлийг зохиогчийн нэр хаяггүйгээр илгээж:
            <ol type="a">
              <li>хэвлэх</li>
              <li>эс хэвлэх</li>
              <li>нэхцэлтэйгээр хэвлэх гэсэн санал</li>
            </ol>
          </li>
          <li>Бүтээлийг нийтлэх эсэхийг редакцын зөвлөлийн дүгнэлтийг харгалзан эцэслэн шийдвэрлэнэ.</li>
        </ol>
      </section>

      <section className="template-section">
        <h2>“ЭМНЭЛЗҮЙН АРЬС СУДЛАЛ” СЭТГҮҮЛИЙН ЗОХИОГЧИД ӨГӨХ ЗАГВАР</h2>
        
        <h1>Гарчиг бүтнээр</h1>
        
        <p>
          <strong>Нэгдүгээр зохиогчийн овог, нэр</strong> [1], <strong>Хоёрдугаар зохиогчийн овог, нэр</strong>[2] гэх мэт, ... <strong>Хариуцлагатай зохиогчийн овог, нэр</strong>[3]
        </p>
        
        <p>
          <sup>1</sup> Тэнхм/Тасаг, Байгууллага, Хот, Улс<br />
          (Жишээ нь:<br />
          <sup>1</sup>Арьс Судлалын Тэнхм, Анагаах Ухааны Сургууль, Анагаахын Шинжлэх Ухааны Их Сургууль,<br />
          <sup>2</sup>Лабораторийн тасаг, Арьсны Өвчин Судлалын Үндэсний Төв, Улаанбаатар хот, Монгол Улс;<br />
          <sup>3</sup>Арьс Судлалын Тэнхм, Ионсей Их Сургуулийн Анагаах Ухааны Коллеж, Сеул хот, БНСУ)
        </p>
        
        <h3>Товч гарчиг: 10 үгэнд багтаан бичнэ</h3>
        
        <h3>Хариуцлагатай зохиогч:</h3>
        <p>
          Овог Нэр, Хамгийн дээд эрдмийн зэрэг<br />
          Тэнхм/Тасаг, Байгууллага, Хот, Улс, Зип код болон Улс.<br />
          Утас: +улсын код –утасны дугаар<br />
          Э-шуудан: имэйл хаяг
        </p>
        
        <h3>Зорилго: Зорилгоо товч бичнэ</h3>
        
        <h3>Материал арга зүй: Судалгаанд хэрэглэсэн хэрэглэгдэхүүн ашигласан аргаа товч бичнэ</h3>
        
        <h3>Үр дүн: Үр дүнгээ товч бичих</h3>
        
        <h3>Дүгнэлт: Дүгнэлтээ бичнэ</h3>
        
        <h3>Түлхүүр үг: MeSH-н загварын дагуу</h3>
        
        <h2>Үндэслэл</h2>
        <p>
          Үндэслэл болох тоо баримт [1] онолын суурь ухагдахуун, таамаглал, судлах шалтгаан зэргийг
          бичнэ [2-3].
        </p>
        
        <h2>Материал арга зүй</h2>
        
        <h3>1. Арга зүйн дэд гарчиг</h3>
        <p>Арга зүйтэй холбогдолтой мэдээлэл бичнэ</p>
        
        <h3>2. Статистик боловсруулалт</h3>
        <p>Статистик бодолт, боловсруулалтыг ямар аргаар, хэрхэн хийснээ бичнэ</p>
        
        <h2>Үр дүн</h2>
        
        <h3>1. Үр дүн дэд гарчиг</h3>
        <p>Үр дүнгийн талаар бичих.</p>
        
        <h3>2. Үр дүн дэд гарчиг</h3>
        <p>Үр дүнгийн талаар бичих.</p>
        
        <h3>3. Үр дүн дэд гарчиг</h3>
        <p>Үр дүнгийн талаар бичих.</p>
        
        <h3>Хүснэгт 1. Хүснэгтийн нэр</h3>
        <table>
          <thead>
            <tr>
              <th>Толгой</th>
              <th>Дата (нэгж)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Нэр</td>
              <td>#</td>
            </tr>
            <tr>
              <td>Нэр</td>
              <td>#</td>
            </tr>
            <tr>
              <td>Нэр</td>
              <td>#</td>
            </tr>
          </tbody>
        </table>
        
        <h3>Хүснэгт 2. Хүснэгтийн нэр</h3>
        <table>
          <thead>
            <tr>
              <th>Гарчиг</th>
              <th>Дата (нэгж)<sup>a</sup></th>
              <th>Категори</th>
              <th>Категори</th>
              <th>Категори</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Нэр</td>
              <td>#<sup>b</sup></td>
              <td>#</td>
              <td>#</td>
              <td>#</td>
            </tr>
            <tr>
              <td>Нэр</td>
              <td>#</td>
              <td>#</td>
              <td>#</td>
              <td>#</td>
            </tr>
            <tr>
              <td>Нэр</td>
              <td>#</td>
              <td>#</td>
              <td>#</td>
              <td>#</td>
            </tr>
          </tbody>
        </table>
        <p><sup>a</sup>Тайлбар [<sup>b</sup>]Тайлбар</p>
        
        <h3>Зураг 1. [ ] Зургийн товч нэр. (а) Зургийн тайлбар. (б) Зургийн тайлбар (статистик утга, бодолтын тайлбар бүхий)</h3>
        
        <h3>Зураг 2. [ ] Зургийн товч нэр. (а) Зургийн тайлбар. (б) Зургийн тайлбар (статистик утга, бодолтын тайлбар бүхий)</h3>
        
        <h2>Хэлцэмж</h2>
        <p>
          Хэлцэмж мэдээлэл [4]. Хэлцэмж мэдээллийн бусад судлаачид болон гадаад оронд судлагдсан
          байдлын талаар бичих [5]. (Судалгааны үр дүнгийн талаар өөрийн оюун дүгнэлт болон бусад
          судлаачдын үр дүнг харьцуулан тайлбарлах)
        </p>
        
        <h2>Дүгнэлт</h2>
        <p>Судалгаанаас гарсан үр дүнг зорилготой уялдуулан бичнэ.</p>
        
        <h2>Ашиг сонирхолын зөрчил</h2>
        <p>Зохиогчид ашиг сонирхолын зөрчилгүй талаар мэдэгдэнэ.</p>
        
        <h2>Талархал</h2>
        <p>Санхүүжилт болон бусад талархал.</p>
        
        <h2>Ном зүй</h2>
        <ol>
          <li>Ном зүй.</li>
          <li>Ном зүй.</li>
          <li>Ном зүй.</li>
          <li>Ном зүй.</li>
          <li>Ном зүй.</li>
        </ol>
        <p>
          Ишлэл зүүлт, ашигласан лавлагаа материалын жагсаалтыг бичихдээ био анагаахын сэтгүүлд
          хэвлүүлэхэд тавигддаг олон улсын нийтлэг жишгийн дагуу бичнэ (Uniform requirements for
          manuscripts submitted to biomedical journals : J Pharmacol Pharmacother. 2010 Jan-Jun; 1(1): 42–58)
        </p>
      </section>
    </div>
  );
};

export default Handbook;